export default __webpack_public_path__ + "static/video-preview-1-288954bbd26926036a5d549ba4ee7db8.webp";